import { Link } from "react-router-dom";
// import logoImg from 'frontend/src/img/logo.svg';

import { useImages } from '../general/ImageProvider';
import { urlFor } from '../lib/imageUrl';

function Navbar(props) {


  const images = useImages();

  if (!Array.isArray(images) || !images.length) {
    return <div>Loading...</div>;
  }

  // Helper function to find an image by title
  const getImageByTitle = (title) => {
    return images.find((image) => image.title === title);
  };

  const logo = getImageByTitle('Logo');


  return (
    <header className="global-header" >
      <nav className="">
        <div className="wrapper">
          <div className="logo">  <Link to="/" >
            <div className="logo-details text-center">

              {/* <img src={logoImg} alt="" className="img-fluid" /> */}
              {logo && (

                <img
                  src={urlFor(logo.file.asset).width(500).url()}
                  alt={logo.altText || 'Sanity Image'}
                />

              )}

            </div>
          </Link></div>
          <input type="radio" name="slider" id="menu-btn" />
          <input type="radio" name="slider" id="close-btn" />
          <ul className="nav-links">
            <label htmlFor="close-btn" className="btn close-btn"><i class='bx bx-chevrons-left'></i></label>
            <li><Link to="/">{props.navtitle}</Link></li>


            <li><Link to="/social-automation">Social Studio</Link></li>
            <li>
              <Link to="/text-gizmo" className="desktop-item">{props.texttitle}</Link>
              <input type="checkbox" id="showMega" />
              <label htmlFor="showMega" className="mobile-item"> {props.texttitle} </label>
              <div className="mega-box">
                <div className="content">
                  <div className="row">
                    <img src="https://fadzrinmadu.github.io/hosted-assets/responsive-mega-menu-and-dropdown-menu-using-only-html-and-css/img.jpg" alt="" />
                  </div>
                  <div className="row">
                    <header>Text Gizmo</header>
                    <ul className="mega-links">
                      <li><Link to="text-gizmo/convert-case">Case Converter</Link></li>
                      <li><Link to="text-gizmo/replace-text">Text Replacement Tool</Link></li>

                    </ul>
                  </div>
                  <div className="row">
                    <header>Code Gizmo</header>
                    <ul className="mega-links">
                      <li><Link to="/code-gizmo/html-beautify">HTML Formatter</Link></li>
                      <li><Link to="/code-gizmo/html-beautify">CSS Formatter</Link></li>
                      <li><Link to="/code-gizmo/html-beautify">JS Formatter</Link></li>

                    </ul>
                  </div>
                  <div className="row">
                    <header>Misc.. Gizmo</header>
                    <ul className="mega-links">
                      <li><Link to="/code-gizmo/html-beautify">Sort Words Alphabetically</Link></li>
                      <li><Link to="/code-gizmo/html-beautify">Password Generator</Link></li>

                    </ul>
                  </div>

                </div>
              </div>
            </li>
            {/* <li>
            <Link to="/image-gizmo" className="desktop-item">{props.imgtitle}</Link>
            <input type="checkbox" id="showMega1" />
            <label htmlFor="showMega1" className="mobile-item"> {props.imgtitle} </label>
            <div className="mega-box">
              <div className="content">
                <div className="row">
                  <img src="https://fadzrinmadu.github.io/hosted-assets/responsive-mega-menu-and-dropdown-menu-using-only-html-and-css/img.jpg" alt="" />
                </div>
                <div className="row">
                  <header>Image Gizmo</header>
                  <ul className="mega-links">
                    <li><Link to="png-to-webp">PNG to WEBP</Link></li>
                    <li><Link to="jpg-to-webp">JPG to WEBP</Link></li>
                    
                  </ul>
                </div>
                <div className="row">
                  <header>Image Gizmo</header>
                  <ul className="mega-links">
                    <li><Link to="png-to-webp">PNG to WEBP</Link></li>
                    <li><Link to="jpg-to-webp">JPG to WEBP</Link></li>
                   
                  </ul>
                </div>
                <div className="row">
                  <header>Image Gizmo</header>
                  <ul className="mega-links">
                    <li><Link to="#">PNG to WEBP</Link></li>
                    <li><Link to="#">JPG to WEBP</Link></li>
                  
                  </ul>
                </div>
                <div className="row">
                  <header>Email Services</header>
                  <ul className="mega-links">
                    <li><Link to="#">Personal Email</Link></li>
                    <li><Link to="#">Business Email</Link></li>
                    <li><Link to="#">Mobile Email</Link></li>
                    <li><Link to="#">Web Marketing</Link></li>
                  </ul>
                </div>
                <div className="row">
                  <header>Security services</header>
                  <ul className="mega-links">
                    <li><Link to="#">Site Seal</Link></li>
                    <li><Link to="#">VPS Hosting</Link></li>
                    <li><Link to="#">Privacy Seal</Link></li>
                    <li><Link to="#">Website design</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </li> */}

            <li>
              <Link to="/insights" className="desktop-item">{props.insighttitle}</Link>
              {/* <input type="checkbox" id="showDrop" />
           
            <ul className="drop-menu">
              <li><Link to="#">Drop menu 1</Link></li>
              <li><Link to="#">Drop menu 2</Link></li>
              <li><Link to="#">Drop menu 3</Link></li>
              <li><Link to="#">Drop menu 4</Link></li>
            </ul> */}
            </li>
            <li><Link to="/contact">{props.contacttitle}</Link></li>
          </ul>
          <label htmlFor="menu-btn" className="btn menu-btn"><i class='bx bx-menu-alt-right'></i></label>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
